module.exports = __webpack_public_path__ + "img/euc-step3.66b6d095.png";